import { IBaseShop } from '@lla-platform/core/core-data-access'
import { LocationAttentionLevel } from '@lla-platform/core/core-data-access'

export interface IShopLocationItem extends IBaseShop {
  latitude: number
  longitude: number
}

export interface IStatusBoardComments {
  operations?: string
  recruiting?: string
  equipment?: string
}

export interface IStatusBoardGrowthMonth {
  label: string
  // Absent when there is no meaningful comparison (previous-year total is zero)
  growth?: number
  // Absent when there is no meaningful comparison (previous-year car count is zero)
  carCountGrowth?: number
  // The compared months start before the Takeover Date: totals include the previous owner's days
  includesPreTakeoverDays: boolean
}

export interface IStatusBoardForecastDay {
  dayOfWeekName: string
  dayCount: number
  avgSales: number
  totalSales: number
}

// Current-month sales projection: actual month-to-date plus day-of-week forecast
// for the remaining days, compared against last year's full same month
export interface IStatusBoardForecast {
  label: string
  monthName: string
  lastYearMonthName: string
  actualSales: number
  forecastedSales: number
  projectedSales: number
  lastYearSales: number
  // Absent when there is no meaningful comparison (last-year month total is zero)
  growth?: number
  // Last year's same month starts before the Takeover Date: lastYearSales includes the previous owner's days
  lastYearIncludesPreTakeoverDays: boolean
  // The current month or the recent-weeks averaging window starts before the Takeover Date:
  // forecastedSales (and so projectedSales) may include the previous owner's days
  forecastIncludesPreTakeoverDays: boolean
  forecastDays: IStatusBoardForecastDay[]
}

// Flagged Period marker (see GLOSSARY.md → Status Board): one wording, shared by the
// board card, the forecast dialog and the admin status proposals table
export const PRE_TAKEOVER_NOTE = '* includes days not operated by LLA'
export const preTakeoverMark = (flagged: boolean): string => (flagged ? '*' : '')
export const flagPreTakeover = (label: string, flagged: boolean): string =>
  `${label}${preTakeoverMark(flagged)}`

export interface IStatusBoardLocationItem {
  id: string
  name?: string
  address?: string
  state?: string
  regionalManagerName?: string
  districtManagerName?: string
  attentionLevel?: LocationAttentionLevel
  comments?: IStatusBoardComments
  growthMonths?: IStatusBoardGrowthMonth[]
  forecast?: IStatusBoardForecast
}

export interface IStatusBoardResponse {
  locations: IStatusBoardLocationItem[]
}

// Red/yellow/green counts across the user's active permitted locations
export interface IAttentionSummaryResponse {
  red: number
  yellow: number
  green: number
}

export interface IEditLocationAttentionRequest {
  attentionLevel: LocationAttentionLevel
  operations: string
  recruiting: string
  equipment: string
}
